import { render, staticRenderFns } from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=template&id=bb90c9ca&scoped=true&lang=pug"
import script from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=bb90c9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb90c9ca",
  null
  
)

export default component.exports